
import React from "react";

const Footer = () => {
  return (
    <>
      <div className="Footer" id="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-5 col-12 ft-1">
              <h3>
                <span>SUNGURA</span> CREATIVES
              </h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Laborum ea quo ex ullam laboriosam magni totam, facere eos iure
                voluptate.
              </p>
              <div className="footer-icons">
                <i className="fa-brands fa-facebook"></i>
                <i className="fa-brands fa-twitter"></i>
                <i className="fa-brands fa-instagram"></i>
                <i className="fa-brands fa-linkedin-in"></i>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-12 ft-2">
              <h5>Quick Links</h5>
              <ul>
                <li className="nav-item">
                  <a className="" href="/">
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a className="" href="/videos">
                    Portfolio
                  </a>
                </li>
                <li className="nav-item">
                  <a className="" href="/team">
                    Team
                  </a>
                </li>
                <li className="nav-item">
                  <a className="" href="/">
                    Contact Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="" href="/">
                    Careeers
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-4 col-12 ft-3">
              <h5>Quick Links</h5>
              <p>
                <i className="fa-solid fa-phone-volume"></i> +254 707738434
              </p>
              <p>
                <i className="fa-solid fa-envelope"></i> finepiver@gmail.com
              </p>
              <p>
                <i className="fa-solid fa-paper-plane"></i> Utawala, Nairobi.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="Last-footer"
        style={{
          paddingBottom: "2rem",
          paddingTop: "1rem",
          textAlign: "center",
        }}
      >
        <p>
          Design By Joseph Thogo AKA{" "}
          <span style={{ color: "red" }}>Gasta Piva</span>
        </p>
        <button  className="btn btn-primary">
          <a href="#landing-page">back to top</a>
        </button>
      </div>
    </>
  );
};

export default Footer;
